<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="vl-toolbar">
          <input class="vl-input" type="search" placeholder="Cari nama pengguna atau catatan&hellip;"
                 aria-label="Cari pengaduan" [value]="isKeyword"
                 (input)="onKeywordInput($event.target.value)" (keyup.enter)="applyFilter()">
          <select class="vl-select" aria-label="Filter kategori"
                  (change)="isCategory = $event.target.value; applyFilter()">
            <option value="">Semua kategori</option>
            <option value="wrong_pronunciation">Salah Pengucapan</option>
            <option value="lack_of_verses">Kekurangan Ayat</option>
            <option value="excess_verses">Kelebihan Ayat</option>
          </select>
          <select class="vl-select" aria-label="Filter status"
                  (change)="isStatus = $event.target.value; applyFilter()">
            <option value="">Semua status</option>
            <option value="submitted">Belum Diperbaiki</option>
            <option value="approved">Sudah Diperbaiki</option>
          </select>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="vl-card">
              <div class="vl-loading" *ngIf="isTableLoading">
                <img src="assets/images/preloaders/3.svg" class="vl-loading-img" alt="Memuat data">
              </div>
              <div class="vl-scroll">
              <table class="vl-table">
                <thead>
                <tr>
                  <th class="vl-num">No</th>
                  <th>Tanggal</th>
                  <th>Pengguna</th>
                  <th>Kategori</th>
                  <th>Rentang Ayat</th>
                  <th>Status</th>
                  <th class="text-right">Aksi</th>
                </tr>
                </thead>
                <tbody>
                <ng-container *ngFor="let v of isData; let i = index">
                  <tr class="vl-top" [class.vl-alt]="i % 2 == 1" (click)="toggleRow(v)">
                    <th class="vl-num">
                      {{rowNo(i)}}
                      <span class="vl-chev" [class.open]="isExpanded[v.id]"><i class="fa fa-chevron-right"></i></span>
                    </th>
                    <td class="vl-muted vl-small">{{v.createdVw}}</td>
                    <td><span class="vl-name" [innerHTML]="highlight(v.userName)"></span></td>
                    <td><span class="vl-tag cat">{{v.categoryVw}}</span></td>
                    <td class="vl-muted">{{v.rangeVw}}</td>
                    <td>
                      <span *ngIf="v.status === 'approved'" class="vl-pill on"><span class="vl-dot"></span>Sudah Diperbaiki</span>
                      <span *ngIf="v.status !== 'approved'" class="vl-pill wait"><span class="vl-dot"></span>Belum Diperbaiki</span>
                    </td>
                    <td>
                      <div class="vl-actions">
                        <button *ngIf="v.status !== 'approved'" type="button" class="vl-icon done" title="Tandai sudah diperbaiki"
                                (click)="$event.stopPropagation(); askStatus(v)"><i class="fa fa-check"></i></button>
                        <button *ngIf="v.status === 'approved'" type="button" class="vl-icon undo" title="Tandai belum diperbaiki"
                                (click)="$event.stopPropagation(); askStatus(v)"><i class="fa fa-undo"></i></button>
                      </div>
                    </td>
                  </tr>
                  <ng-container *ngIf="isExpanded[v.id]">
                    <tr *ngIf="v.notes" class="vl-child">
                      <th class="vl-num"></th>
                      <td colspan="6">
                        <div class="vc-notes">
                          <span class="vc-notes-label">Catatan pengguna</span>
                          <span class="vc-notes-text" [innerHTML]="highlight(v.notes)"></span>
                        </div>
                      </td>
                    </tr>
                    <tr *ngFor="let a of v.audio; let j = index" class="vl-child">
                      <th class="vl-num">{{rowNo(i)}}.{{j + 1}}</th>
                      <td colspan="5">
                        <span class="vl-file-wrap">
                          <span class="vl-tree">&#9492;</span>
                          <span class="vl-ayah-chip">{{surahName(a.surah)}} &middot; Ayat {{a.ayah}}</span>
                          <button type="button" class="vl-icon play" [class.on]="playingId === a.id" *ngIf="a.file"
                                  [title]="playingId === a.id ? 'Jeda' : 'Putar'" (click)="togglePlay(a)">
                            <i class="fa" [ngClass]="playingId === a.id ? 'fa-pause' : 'fa-play'"></i></button>
                          <code class="vl-code" *ngIf="a.file">{{a.file}}</code>
                          <span class="vl-muted" *ngIf="!a.file">&mdash;</span>
                        </span>
                      </td>
                      <td>
                        <div class="vl-actions">
                          <button type="button" class="vl-icon" title="Perbaiki audio" (click)="onEdit(a)" data-bs-toggle="modal"
                                  data-bs-target="#formData"><i class="fa fa-edit"></i></button>
                          <button type="button" class="vl-icon danger" title="Hapus audio" (click)="askDeleteAudio(v, a)"><i class="fa fa-trash"></i></button>
                        </div>
                      </td>
                    </tr>
                    <tr *ngIf="!v.audio || !v.audio.length" class="vl-child">
                      <th class="vl-num"></th>
                      <td colspan="6" class="vl-muted vl-small">Tidak ada file audio pada rentang ayat ini.</td>
                    </tr>
                  </ng-container>
                </ng-container>
                <tr *ngIf="!isData.length">
                  <td colspan="7" class="vl-empty">Tidak ada data</td>
                </tr>
                </tbody>
              </table><!--end /table-->
              </div>
              <div class="vl-foot">
                <span class="vl-summary">Menampilkan <b>{{formatNumber(summaryFrom())}}&ndash;{{formatNumber(summaryTo())}}</b> dari <b>{{formatNumber(isTotalAll)}}</b> pengaduan</span>
                <div class="vl-spacer"></div>
                <nav class="vl-pager" aria-label="Navigasi halaman">
                  <button type="button" class="vl-page" [disabled]="isPage == 1" (click)="goToPage(isPage - 1)">&lsaquo;</button>
                  <ng-container *ngFor="let p of isPages">
                    <span *ngIf="p == '...'" class="vl-ellipsis">&hellip;</span>
                    <button *ngIf="p != '...'" type="button" class="vl-page" [class.active]="p == isPage"
                            (click)="goToPage(p)">{{p}}</button>
                  </ng-container>
                  <button type="button" class="vl-page" [disabled]="isPage == totalPages()" (click)="goToPage(isPage + 1)">&rsaquo;</button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- audio fix dialog -->
<form [formGroup]="isForm" (ngSubmit)="onSubmit()">
  <div class="modal fade" id="formData" aria-labelledby="formDataLabel" aria-hidden="true" data-keyboard="false"
       data-backdrop="static">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header vf-header">
          <div>
            <h6 class="modal-title vf-title" id="formDataLabel">Perbaiki audio</h6>
            <div class="vf-subtitle">Perbarui {{isEditLabel}}.</div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" [disabled]="isLoading"></button>
        </div>
        <div class="modal-body">
          <div class="vf-grid">
            <div class="vf-field full" [class.vf-invalid]="isInvalid('surah')">
              <label class="vf-label">Surat <span class="req">*</span></label>
              <ng-select2 formControlName="surah" [data]="dataSurah"
                          [placeholder]="'Pilih surat'"></ng-select2>
              <div class="vf-error" *ngIf="isInvalid('surah')">Surat wajib dipilih.</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">Ayat <span class="req">*</span></label>
              <input type="number" min="1" inputmode="numeric" class="vf-input" [class.invalid]="isInvalid('ayah')"
                     placeholder="Nomor ayat, misal: 1" formControlName="ayah">
              <div class="vf-error" *ngIf="isInvalid('ayah')">Ayat wajib diisi (minimal 1).</div>
            </div>
            <div class="vf-field full">
              <label class="vf-label">File Audio</label>
              <input class="vf-input vf-file" type="file" accept="audio/*"
                     formControlName="file" (change)="onFileSelect($event)">
              <div class="vf-hint">Biarkan kosong jika file tidak diganti.</div>
            </div>
          </div>
        </div>
        <div class="modal-footer vf-footer">
          <button type="button" class="vl-btn-ghost" data-bs-dismiss="modal" [disabled]="isLoading">Batal</button>
          <button type="submit" class="vl-btn-primary" [disabled]="isLoading">
            <i class="fa fa-spinner fa-spin" *ngIf="isLoading"></i> Simpan</button>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- confirmation (status toggle / audio delete) -->
<div class="hds-overlay" *ngIf="isConfirm" (click)="closeConfirm()">
  <div class="hds-dialog" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">

    <ng-container *ngIf="isConfirm.mode == 'status'">
      <div class="hds-b">
        <h3>{{isConfirm.to === 'approved' ? 'Tandai sudah diperbaiki?' : 'Kembalikan ke belum diperbaiki?'}}</h3>
        <p class="hds-sub">Periksa kembali sebelum menyimpan.</p>
        <div class="hds-panel">
          <div class="hds-row"><span>Pengguna</span><b>{{isConfirm.v.userName}}</b></div>
          <div class="hds-row"><span>Rentang</span><b>{{isConfirm.v.rangeVw}}</b></div>
          <div class="hds-row"><span>Status</span>
            <b>{{statusLabel(isConfirm.v.status)}} &rarr; {{statusLabel(isConfirm.to)}}</b></div>
        </div>
      </div>
      <div class="hds-foot hds-foot-end">
        <button type="button" class="vl-btn-ghost" [disabled]="isSaving" (click)="closeConfirm()">Batal</button>
        <button type="button" class="vl-btn-primary" [disabled]="isSaving" (click)="confirmStatus()">
          <i class="fa fa-spinner fa-spin" *ngIf="isSaving"></i>
          {{isConfirm.to === 'approved' ? 'Ya, Sudah Diperbaiki' : 'Ya, Belum Diperbaiki'}}</button>
      </div>
    </ng-container>

    <ng-container *ngIf="isConfirm.mode == 'audio-delete'">
      <div class="hds-a">
        <span class="hds-ico">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round"><path d="M3 6h18M8 6V4h8v2m-9 0l1 14h8l1-14"/></svg>
        </span>
        <h3>Hapus audio ini?</h3>
        <p>Tindakan ini tidak bisa dibatalkan.</p>
        <div class="hds-item">
          <span>{{surahName(isConfirm.a.surah)}} &mdash; Ayat {{isConfirm.a.ayah}}</span>
        </div>
        <div class="hds-file" *ngIf="isConfirm.a.file"><code class="vl-code">{{isConfirm.a.file}}</code></div>
      </div>
      <div class="hds-foot hds-foot-full">
        <button type="button" class="vl-btn-ghost" [disabled]="isSaving" (click)="closeConfirm()">Batal</button>
        <button type="button" class="hds-btn-danger" [disabled]="isSaving" (click)="confirmDeleteAudio()">
          <i class="fa fa-spinner fa-spin" *ngIf="isSaving"></i> Hapus</button>
      </div>
    </ng-container>

  </div>
</div>
